<template>
    <div class="down-menu">
        <i class="iconfont icon-caidan1 btn-text" @click="show = !show"></i>
        <div class="down-body" v-if="show" @click="show = !show">
            <div class="list">
                <!-- <div @click="onMenu('home')" class="list-item">首页</div> -->
                <div @click="onMenu('/pageSearch')" class="list-item">中药材</div>
                <div @click="onMenu('/pageBook')" class="list-item">中医书籍</div>
                <div @click="onMenu('/chatGpt')" class="list-item">慈脉ChatGPT</div>
                <div @click="onMenu('quit')" class="list-item">退出</div>
            </div>
            <div class="btn-bl">
                <u-switch class="sj" v-model="mk_isDark" @change="darkChange"></u-switch>
            </div>
        </div>
    </div>
</template>

<script>
import USwitch from '@/components/uSwitch.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        USwitch,
    },
    computed: {
        ...mapGetters(['isDark']),
    },
    watch: {
        isDark() {
            this.mk_isDark = this.isDark
        }
    },
    data() {
        return {
            show: false,
            mk_isDark: false,
        }
    },
    methods: {
        darkChange() {
            this.$store.commit("setIsDark", this.mk_isDark);
        },
        onMenu(res) {
            switch (res) {
                case 'quit':
                    this.$store.commit("logout")
                    break;

                default:
                    this.jump(res)
                    break;
            }
        }
    },
    created() {
        this.mk_isDark = this.isDark;
    },
}
</script>

<style lang="scss" scoped>
.down-menu {
    display: inline-block;

    .btn-bl {
        padding: 30px 0;
        text-align: center;
    }

    .btn-text {
        text-align: center;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: left;
        display: inline-block;
        transform: rotate(180deg);
    }

    .down-body {
        position: absolute;
        z-index: 100;
        top: 55px;
        left: 0;
        width: 100%;
        height: calc(100vh - 55px);
        background: #fff;
        box-sizing: border-box;
        padding: 15px;

        .list {
            .list-item {
                border-bottom: 1px solid #eee;
                line-height: 40px;
            }
        }
    }

}
</style>
